import api from "./api";

// GET FOOTER
export const getFooter = async () => {
  return await api.get("/footer");
};

// GET FOOTER BY ID
export const getFooterById = async (id) => {
  return await api.get(`/footer/${id}`);
};

// CREATE FOOTER
export const createFooter = async (data) => {
  return await api.post("/footer", data);
};

// UPDATE FOOTER
export const updateFooter = async (id, data) => {
  return await api.put(`/footer/${id}`, data);
};

// DELETE FOOTER
export const deleteFooter = async (id) => {
  return await api.delete(`/footer/${id}`);
};